import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { FileUploadService } from '@services/file.upload.service';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
var LibraryService = /** @class */ (function (_super) {
    tslib_1.__extends(LibraryService, _super);
    function LibraryService(http, _fileUploadService) {
        var _this = _super.call(this, http, MapperService.packageMap) || this;
        _this._fileUploadService = _fileUploadService;
        _this._endpoint = 'odata/Libraries';
        return _this;
    }
    LibraryService.prototype.getVersions = function (packageId, queryOptions) {
        return this.get(queryOptions, this._endpoint + "/UiPath.Server.Configuration.OData.GetVersions(packageId='" + packageId + "')");
    };
    LibraryService.prototype.uploadPackages = function (files) {
        return this._fileUploadService.uploadFiles(files, this._endpoint + "/UiPath.Server.Configuration.OData.UploadPackage()");
    };
    LibraryService.prototype.downloadLink = function (entry) {
        return this._endpoint + "/UiPath.Server.Configuration.OData.DownloadPackage(key='" + entry.key + "')";
    };
    return LibraryService;
}(ODataService));
export { LibraryService };
